import React from 'react';
import MuiTablePagination from '@mui/material/TablePagination';
export const TablePagination = ({ count, page, onPageChange, _sx, rowsPerPage, showFirstButton = false, showLastButton = false, dataTestId, }) => {
    return (React.createElement(MuiTablePagination, { count: count, page: page, onPageChange: onPageChange, rowsPerPage: rowsPerPage, sx: _sx, 
        /**
         * This configuration to hide Rows Per Page components
         */
        rowsPerPageOptions: [], showFirstButton: showFirstButton, showLastButton: showLastButton, "data-testid": dataTestId }));
};
